export default [
  {
    text: "This form should be completed by students who wish to appeal for remarking of their examination paper(s). The form should be received by KISEB within fourteen (14) days after the date of release of the examination results. This date is indicated in the examination result notification. Students paying through the banks or other agents should personally send the forms attaching copies of deposit slips to KISEB so as to be received within the stated deadline. Appeal forms received after the stated deadline will not be considered.",
  },
  {
    text: "Students are ADVISED not to make the appeal decision in a rush and to note that no extraneous circumstances will be considered during the remarking.",
  },
  {
    text: "Your name should NOT appear anywhere on this form.",
  },
  {
    text: "The form should be delivered in person or sent by post. Email and other electronic media should NOT be used.",
  },
  {
    text: "A remarking fee shall be charged at Sh. 5,000 per paper for APS level I and Level II examinations and Sh.7, 500 per paper for CPSP examinations. (MPESA PAYBILL: 7604813 (Ac. no. YourNname), BANK DETAILS: Account Name: Kenya Institute of Examination Board, Account No. 01020230718100, National Bank of Kenya- Ngong Road Branch)",
  },
  {
    text: "A refund of the remarking fee, less an administrative charge of 15% shall be made if, after the remarking, the student's results for a particular paper change from FAIL to PASS.",
  },
  {
    text: "You will be required to commit yourself to accept the outcome of the remarking as final.",
  },
  {
    text: "You should attach a copy of the receipt or bank deposit slip for the remarking fee.",
  },
];
